
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.6 29.6V17.7c0-1.9 1.4-1.9 1.4 0v13.5c0 .4-.1 1.6-.7 1.6h-9.9c-1 0-1-3.2 0-3.2h9.2z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 30C8 17.8 17.6 7 30.1 7 43 7 51.9 17.8 52.2 30c-.3 12.2-9.3 23-22.1 23C17.6 53 8 42.2 8 30zm1.4 0c0 11.1 9.9 19.9 20.7 19.9 11.1 0 20.5-8.8 20.8-19.9-.3-11.4-10.1-20.2-21.4-19.9-10.6.4-20.1 9-20.1 19.9z"}})])
          )
        }
      }
    